import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'

Vue.component('apexchart', VueApexCharts)

export default VueApexCharts



// WEBPACK FOOTER //
// ./src/plugins/vue-apexcharts.js